import { useOnClickOutside } from '@elotech/components';
import { useContext, useRef } from 'react';

import { progressStatusIcons } from '../../type/enum';
import { ProgressContext } from './ProgressContainer';

export const ProgressContent = () => {
  const { modalVisible, progresses, descartarProgresso, setModalVisible } =
    useContext(ProgressContext);
  const contentRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(contentRef, () => {
    if (modalVisible) {
      setTimeout(() => {
        setModalVisible?.(false);
      }, 200);
    }
  });

  const descartarTudo = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    Object.keys(progresses || {}).forEach(id => {
      descartarProgresso?.(id);
    });
  };

  const onClick = (id: string) => (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const el = e.currentTarget;
    el.style.opacity = '0.5';
    descartarProgresso?.(id);
  };

  const visible = modalVisible && progresses && Object.keys(progresses).length;

  const renderMessageSplitingLines = (message: string) => {
    return `${message}`.includes('\n')
      ? message
          .replace('\r', '')
          .split('\n')
          .map((line, index, ar) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))
      : message;
  };

  return (
    <div
      className={`features-user auto-height order-3 ${visible ? 'active' : ''}`}
      style={{ width: '50%' }}
      ref={contentRef}
    >
      <h2 className="title">Progresso de tarefas</h2>

      <ul className="user-actions">
        <li className="features-section">Clique no progresso para descartar</li>
        <li
          className="no-link"
          onClick={descartarTudo}
          role="button"
          aria-label="Descartar todas"
        >
          Descartar todas
        </li>
        {Object.entries(progresses || {}).map(([, progress]) => {
          return (
            <li
              style={{ flexDirection: 'column', alignItems: 'flex-start' }}
              key={progress.id}
              onClick={onClick(progress.id)}
              className="no-link"
              role="button"
            >
              <b>{progress.title}</b>
              <span>
                <i className={progressStatusIcons[progress.status]} />
                {renderMessageSplitingLines(progress.message)}
              </span>

              {!!progress.percentage && progress.running && (
                <div
                  style={{
                    width: '100%',
                    height: '8px',
                    backgroundColor: '#eee',
                    borderRadius: '4px',
                    marginTop: '4px',
                    overflow: 'hidden'
                  }}
                >
                  <div
                    style={{
                      width: `${progress.percentage}%`,
                      height: '100%',
                      backgroundColor: '#4caf50',
                      transition: 'width 0.5s ease'
                    }}
                  />
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
